import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
    {
        q: "Where can I buy a BookBlend bag?",
        a: "At BookBlend vending machines — coming to airports, coffee shops, doctor's offices, and waiting areas. Every bag shows exactly what's inside, and you can browse the full lineup in the BookBlend app or on this website before you go.",
    },
    {
        q: "How do I pay at the machine?",
        a: "Tap or swipe right at the machine — credit card, Apple Pay, and Google Pay all work. No ordering, no pickup codes, no app checkout needed.",
    },
    {
        q: "What's the difference between Plus and Pro?",
        a: "BookBlend Plus ($9.99/mo) unlocks all reading & community features — chat rooms, unlimited book clubs, weekly discussion questions, journaling, challenges, and reading analytics. BookBlend Pro ($14.99/mo) includes everything in Plus, plus the Social Media Manager with 50 content credits every month.",
    },
    {
        q: "What is the Social Media Manager?",
        a: "It generates ready-to-post content for Instagram, TikTok, and more — captions, hashtags, and a content scheduling calendar. Pro members get 50 content credits per month that refill automatically. Credits don't carry over and can't be topped up.",
    },
    {
        q: "Is there a free trial?",
        a: "Yes — every new membership starts with a free 7-day trial with all features unlocked. You won't be charged until the trial ends, and you can cancel anytime before that at no cost.",
    },
    {
        q: "How do I cancel or pause my membership?",
        a: "Cancel or pause anytime from your account settings. No questions asked, no dark patterns, no retention calls.",
    },
    {
        q: "What can I do with the free app?",
        a: "Free users can browse and swipe books, build their TBR, track their reading, and view the feed. A membership unlocks the clubs, chat rooms, and everything else.",
    },
];

export const FAQSection = () => (
    <section
        id="faq"
        data-testid="faq-section"
        className="py-24 md:py-32 bg-[#F5E9D7]/50 border-y border-[#E5D7C5]"
    >
        <div className="max-w-3xl mx-auto px-6 sm:px-8">
            <div className="text-center mb-12">
                <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C4956A]">
                    Answers
                </span>
                <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-3">
                    Frequently asked questions
                </h2>
            </div>
            <Accordion
                type="single"
                collapsible
                className="space-y-4"
                data-testid="faq-accordion"
            >
                {FAQS.map((item, i) => (
                    <AccordionItem
                        key={item.q}
                        value={item.q}
                        data-testid={`faq-item-${i}`}
                        className="rounded-2xl bg-white border border-[#E5D7C5] px-6 data-[state=open]:shadow-soft"
                    >
                        <AccordionTrigger
                            data-testid={`faq-trigger-${i}`}
                            className="font-serif text-xl md:text-2xl text-left text-[#2D2D2D] py-5 hover:no-underline hover:text-[#C4956A]"
                        >
                            {item.q}
                        </AccordionTrigger>
                        <AccordionContent
                            data-testid={`faq-content-${i}`}
                            className="text-[#6B655C] text-[15px] leading-relaxed pb-6"
                        >
                            {item.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    </section>
);
